/* Copyright (c) 2021 Invicro LLC */

import React from 'react';
import Card, { CardSection } from './card/Card';
import PreformattedText from './PreformattedText';
import Spacer from './Spacer';

const GroupSunset = () => (
  <Card>
    <CardSection hasBorder={false}>
      <PreformattedText
        textClassName="font-headline font-color-gsDark"
        text="groups.sunset.heading"
      />
      <Spacer size="8" />
      <PreformattedText
        textClassName="font-body font-color-gsDark"
        text="groups.sunset.message"
      />
    </CardSection>
  </Card>
);

export default GroupSunset;
